module.exports = __webpack_public_path__ + "static/media/add-tag.dac890e9.svg";